export const dailyTradesReportLocation = "/reports/dailyreports"